(function(){
	window.onload = function(){
		buttonChange();
		hideLoyaltyButton();
	}

	$( window ).resize(function() {
		buttonChange();
	});
	
	
	function buttonChange() {
		// Loop through cart items 
		var cart_items = CartJS.cart.items;
		$(cart_items).each(function(index, value){
			var cart_product = $(cart_items)[index].variant_id;
			var cart_quantity = $(cart_items)[index].quantity;
			var product_id = $('#product_'+cart_product).data('product-id');
			var product_q = $('#product_'+cart_product).data('product-quantity');
			var product_input = $('#product_' + cart_product + ' input.quantity');
			
			// Item in cart matches product on website
			if(cart_product ==  product_id){
				$(product_input).val(cart_quantity);
				var height = $(".add-button").outerHeight() + 20;
				height = height + "px";
				$('#product_' + product_id + ' .add-button').css('margin-top',"-" + height);
				$('#product_' + product_id + ' .add-button').css('transition','margin 500ms');
				$('#product_' + product_id + ' .product_quantity').css('margin-top','-32px');
				$('#product_' + product_id + ' .product_quantity').css('transition','margin 800ms');
				
				product_q = Number(product_q) - Number(cart_quantity);
				$('#product_'+product_id).attr('data-product-quantity', product_q);
				if(product_q == 0 || product_q < 0){
					var oos_height  =  $(".add-button").outerHeight() + 40;
					oos_height = oos_height + "px";
					$('#product_' + product_id + ' .product_quantity').css('margin-top', "-" + oos_height);
					$('#product_' + product_id + ' .product_quantity').css('transition','margin 1200ms');
				}
			}
			
					
		});
	}
	
	// Add to cart button functionality
	$(".add-button").click(function(){
		// Find unique product ID
		var product = $(this).parent().data('product-id');
		
		var height = $(".add-button").outerHeight() + 20;
		height = height + "px";
		// CSS applied when button is clicked to show quantity section with the plus and minus buttons
		$('#product_' + product + ' .add-button').css('margin-top','-'+ height);
		$('#product_' + product + ' .add-button').css('transition','margin 500ms');
		$('#product_' + product + ' .product_quantity').css('margin-top','-32px');
		$('#product_' + product + ' .product_quantity').css('transition','margin 800ms');
		
		// Find stock number from 'data-product-quantity'
		var product_quantity = $('#product_' + product + ' .quantity');
		var product_q = $(this).parent().attr('data-product-quantity');
		product_q = Number(product_q);
		
		// Minus 1 from 'data-product-quantity'
		product_q -= 1;
		$('#product_' + product).attr('data-product-quantity', product_q);
		
		// If stock number = zero for that product then show OOS button
		if(product_q == 0 || product_q < 0){
			var oos_height  =   $(".add-button").outerHeight() + 40;
			oos_height = oos_height + "px";
			$('#product_' + product + ' .product_quantity').css('margin-top',"-" + oos_height);
			$('#product_' + product + ' .product_quantity').css('transition','margin 1200ms');
		}
		
		setTimeout(function() {
			// Increase item quantity by one
			$(product_quantity).val(Number($(product_quantity).val())+1);
		}, 100);
		
		// Add one of item to cart
		CartJS.addItem(product, 1, {},{
			"success": function(data, textStatus, jqXHR) {
			},
			"error": function(jqXHR, textStatus, errorThrown) {
			}
		});
	});
	
	// Plus button functionality
	$('.plus:enabled').click(function(){
		// Get product ID from 'data-product-id'
		var product = $(this).parent().parent().data('product-id');
		
		// Get product quantity from input value
		var product_quantity = $('#product_' + product + ' .quantity');

		// Find stock number from 'data-product-quantity' and Minus one.
		var product_q = $(this).parent().parent().attr('data-product-quantity');
		product_q = Number(product_q);
		product_q -= 1;
		$('#product_' + product).attr('data-product-quantity', product_q);
		
		// Increase quantity by 1
		$(product_quantity).val(Number($(product_quantity).val())+1);

		// Disable Add button for 0.5 seconds
		$('#product_' + product + ' .right').prop('disabled',true);
		$('#product_' + product + ' .right').removeClass('plus');
		setTimeout(function() {
			// Enable Add button
			$('#product_' + product + ' .right').addClass('plus');
			$('#product_' + product + ' .right').prop('disabled',false);
			
			// If stock number = zero for that product then disable add button and show OOS button
			if(product_q == 0 || product_q < 0){
				$('#product_' + product + ' .product_quantity').css('margin-top','-83px');
				$('#product_' + product + ' .product_quantity').css('transition','margin 1200ms');
				$('#product_' + product + ' .right').prop('disabled',true);
				$('#product_' + product + ' .right').removeClass('plus');
			}
		}, 500);
		
		// Add one of item to cart
		CartJS.addItem(product, 1, {},{
			"success": function(data, textStatus, jqXHR) {
			},
			"error": function(jqXHR, textStatus, errorThrown) {
			}
		});
	});

	// Minus button functionaity
	$('.minus:enabled').click(function(){
		// Get product ID from 'data-product-id'
		var product = $(this).parent().parent().data('product-id');
		
		// Get product quantity from input value
		var product_quantity = $('#product_' + product + ' .quantity');
		
		// Find stock number from 'data-product-quantity' and Plus one
		var product_q = $(this).parent().parent().attr('data-product-quantity');
		product_q = Number(product_q);
		product_q += 1;
		$('#product_' + product).attr('data-product-quantity', product_q);
		
		// Decrease quantity by one
		$(product_quantity).val(Number($(product_quantity).val())-1);
		
		// Disable Minus button for 0.5 seconds
		$('#product_' + product + ' .left').prop('disabled',true);
		$('#product_' + product + ' .left').removeClass('minus');
		setTimeout(function() {
			$('#product_' + product + ' .left').addClass('minus');
			$('#product_' + product + ' .left').prop('disabled',false);
			
			// If stock number = zero for that product then disable add button and show OOS button
			if(Number($(product_quantity).val()) == 0){
				// Apply CSS to show add to basket button
				$('#product_' + product + ' .add-button').css('margin-top','0');
				$('#product_' + product + ' .add-button').css('transition','margin 800ms');
				$('#product_' + product + ' .product_quantity').css('margin-top','0');
				$('#product_' + product + ' .product_quantity').css('transition','margin 500ms');
				$('#product_' + product + ' .left').prop('disabled',true);
				$('#product_' + product + ' .left').removeClass('minus');
				setTimeout(function() {
					$('#product_' + product + ' .left').addClass('minus');
					$('#product_' + product + ' .left').prop('disabled',false);
				}, 500);
			}
		}, 500);
		
		if($(product_quantity).val()>=1){
			// Get quantity and remove quantity for the selected item in basket
			var qty = $(product_quantity).val();
			CartJS.updateItemById(product, qty, {},{
				"success": function(data, textStatus, jqXHR) {
				},
				"error": function(jqXHR, textStatus, errorThrown) {
				}
			});
		}else if($(product_quantity).val() < 1){
			// If quantitiy is one then remove item from cart
			CartJS.removeItemById(product);
		}
	});
	
	// Update cart count when items are added/removed
	$(document).on('cart.requestComplete', function(event, cart) {
			if(cart.item_count > 0){
				$('#CartCount').css('opacity','1');
				$('#CartCount span:first').html(cart.item_count);
			} else {
				$('#CartCount').css('opacity','0');
			}
	});
	
	// $(window).bind("scroll.alert", function() {
	// 	var $this = $(this);
	// 	if ($this.scrollTop() >= 1) {
	// 		$('.site-header__icons').css('transition','background-color 0.5s ease').css('background-color','rgba(0,0,0,0.9)');
	// 	} else if($this.scrollTop() < 1) {
	// 		$('.site-header__icons').css('transition','background-color 0.5s ease').css('background-color','rgba(0,0,0,0)');
	// 	}
	// 	if ($this.scrollTop() >= 100) {
	// 		$('.fixed-header-logo').css('transition','opacity 0.5s ease').css('opacity','1');
	// 	} else if($this.scrollTop() < 100) {
	// 		$('.fixed-header-logo').css('transition','opacity 0.5s ease').css('opacity','0');
	// 	}
	// });

	//Get param from URL
function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

	function custom_registration(){
		// Register user via custom API call to set the required params
		function register_user(custom_data) {
			$.ajax({
				type: 'POST',
				crossDomain: true,
				beforeSend: function (xhr) {xhr.setRequestHeader("Access-Control-Allow-Origin", "*");},
				url: 'https://europe-west2-savanna-wh.cloudfunctions.net/scust-creator',
				dataType: 'json',
				contentType: 'application/json; charset=UTF-8;',
				data: JSON.stringify(custom_data),
				success: function(data) {
					window.location.replace('/account/register?registered=true');
				},
				error: function(data, textStatus, errorThrown) {
					//console.log(JSON.stringify(data));
					$.each(data.responseJSON.errors, function( key, value ) {
						$('#custom_registration').prepend('<div class="selection-wrapper"><div class="errors"><p><strong>'+key+'</strong> '+value+'</p></div></div>');
					});
				}
			});
		}
		
		var urlParam = getParameterByName('registered');
		if(urlParam == 'true'){
			$('#custom_registration').prepend('<div class="selection-wrapper"><div class="success"><p>Thanks for signing up to The Savanna.<br />Please be sure to activate your account.</p></div></div>');
		}

		// Custom register form submit
		function custom_registration_submit(){
			$('body').delegate('#custom_registration .submit_button', 'click', function (e) {
				e.preventDefault();

				var first_name = $('#custom_registration #custom_first_name').val();
				var last_name = $('#custom_registration #custom_last_name').val();
				var email = $('#custom_registration #custom_email').val();
				var tags = set_tag_on_input_check('#custom_registration #custom_email','@nhs.net, .nhs.uk, @m-eat.co.uk, @thesavanna.co.uk','NHS');
			
				var custom_data = {
					customer: {
						first_name: first_name,
						last_name: last_name,
						email: email,
						tags: tags
					}
				};
		
				if ($('#custom_registration').valid()) {
					register_user(custom_data);
				}
			});
		}
		custom_registration_submit();

		// Set tags funtion
		function set_tag_on_input_check(element, search_string_comma_seperated, tags_comma_seperated){
			var field = $(element).val();
			var tags = '';
			var search_string_array = search_string_comma_seperated.split(',');
			for(var i = 0; i < search_string_array.length; i++) {
				var search_string = search_string_array[i].trim();
				if(field.toLowerCase().indexOf(search_string) > -1){
					tags += tags_comma_seperated;
				}
			}
			return tags;
		}

		//Validate custom_registration form
		$("#custom_registration").validate({
			rules: {
				'custom_reg[first_name]':{required: true},
				'custom_reg[last_name]':{required: true},
				'custom_reg[email]':{
					required: true,
					email: true
				}
			},
			messages: {
				"custom_reg[email]":{
					email: "Please enter a valid Email Address",
				}
			}
		});
	}

	$(document).ready(function() {
		// Optimalisation: Store the references outside the event handler:
		var $window = $(window);
		var $pane = $('#pane1');

		custom_registration();

		function checkWidth() {
			var windowsize = $window.width();
			if (windowsize <= 749) {
				$('a.site-header__logo-image img').attr('src','https://cdn.shopify.com/s/files/1/0069/6228/2566/files/logo_wide.png?6038');
			} else {
				$('a.site-header__logo-image img').attr('src','https://cdn.shopify.com/s/files/1/0069/6228/2566/files/logo_1.png?5966');
			}
		}
		// Execute on load
		checkWidth();
		// Bind event listener
		$(window).resize(checkWidth);
		
		//Product collapsible/expandable sections
		$('.toggle').click(function() {
			$('.wrap').slideToggle('slow');
			$('.toggle .chevron i').toggleClass('rotate');
			$('.toggle .chevron i').toggleClass('un-rotate');
		});
	});


	$('.mobile-nav--open').click(function(){
		$("html, body").toggleClass("noScroll");
	});
	
})();


//dropdown menu calculation
$(document).ready(function() {
	var link_footer = "closed";
var fromTop = $(".site-nav").innerHeight() + $(".site-nav").offset().top;
$(".site-nav__dropdown").css("top",fromTop);
$(".site-nav--has-dropdown ul").each(function( index ) {
	if( jQuery("li", this).length > 8){
      jQuery("li", this).css("flex", "0 0 50%");
	}
    if( jQuery("li", this).length > 16){
      jQuery("li", this).parent().parent().css("height", "500px");
	}
});

adjustSliderHeight();

$(".footer-menu-dropdown").on("click", function(){ 
	if( link_footer == "closed"){
		$(".site-footer__linklist").css("display", "block");
		link_footer = "open";
		$("#footer_dropdown_img").attr("src","https://cdn.shopify.com/s/files/1/0069/6228/2566/files/upicon.png?v=1622035948");
	}
	else{
		$(".site-footer__linklist").css("display", "none");
		link_footer = "closed";
		$("#footer_dropdown_img").attr("src","https://cdn.shopify.com/s/files/1/0069/6228/2566/files/downicon.png?v=1622035948");
	}
})
//move dropdown position
var fromTop = $(".site-nav").offset().top;
$(".site-nav__dropdown").css("top",fromTop);
$("ul.site-nav").css("position", "relative");
var dropdown = $(".site-nav__dropdown");
for( var i = 0; i < dropdown.length; i++ ){
  if(dropdown.eq(i).parent().offset().top < fromTop + 10){
    dropdown.eq(i).css("top", "50px");
  }
  else{
     dropdown.eq(i).css("top", "94px");
  }
}
window.addEventListener('resize', function(){
var fromTop = $(".site-nav").offset().top;
$(".site-nav__dropdown").css("top",fromTop);
$("ul.site-nav").css("position", "relative");
var dropdown = $(".site-nav__dropdown");
for( var i = 0; i < dropdown.length; i++ ){
  if(dropdown.eq(i).parent().offset().top < fromTop + 10){
    dropdown.eq(i).css("top", "50px");
  }
  else{
     dropdown.eq(i).css("top", "94px");
  }
}
	
	adjustSliderHeight();
});
});

//add arrow to link in homepage
$("#shopify-section-1621115948889e5e49 .rte-setting a").append(' <img style="margin-bottom: 2px;vertical-align: middle; width: 8px;" src="https://cdn.shopify.com/s/files/1/0069/6228/2566/files/red-arrow.png?v=1621284463">')
$("#shopify-section-1621194775913e62c1 .recipe-button").append(' <img style="margin-bottom: 2px;vertical-align: middle; width: 8px;" src="https://cdn.shopify.com/s/files/1/0069/6228/2566/files/red-arrow.png?v=1621284463">')
//video playing 
$(".video_overlay").on("click", function(){
	$('#sav_video').get(0).play();
	$(".video_overlay").remove();
})


//filter collections and redirect to collections page
$(".collection-filter").on("change", function(e){
	e.preventDefault;
	console.log($(this))
	var url = $(this).find(":selected").attr("data-url");
	window.location.href = url;
})		

//change header height
function headerHeight(){
	if( $(window).width() < 749 ){
		var height = $(".announcement-bar").innerHeight() + $(".site-header").innerHeight();
	}
	else{
		var height = $(".announcement-bar").innerHeight() + $(".site-header").innerHeight() + $(".site-nav").innerHeight();
	}
	$("#shopify-section-header").css("height", height );
}
$( document ).ready(headerHeight )
$(window).on("resize",headerHeight )

function adjustSliderHeight(){
	//calculate height of slider image and adjust slider height based on that
	var hidden_img = $(".hidden-slideshow-img");
	var hidden_img_mobile = $(".hidden-slideshow-img-mobile")
	var highest_height = 0;
	if( window.innerWidth > 744 ){
		for( var i = 0; i < hidden_img.length; i++ ){
			var height = hidden_img.eq(i).height();
			if( highest_height < height ){
				highest_height = height;
			}
		}
	}
	else{
		for( var i = 0; i < hidden_img_mobile.length; i++ ){
			var height = hidden_img_mobile.eq(i).height();
			if( highest_height < height ){
				highest_height = height;
			}
		}
	}
	$(".slideshow--medium").css("height", highest_height);
	$(".slick-list").css("height", highest_height);
	$(".slick-track").css("height", highest_height);
	$(".slideshow__slide").css("height", highest_height);
	$(".mobile_slider_slide").css("height", highest_height);
}

// -------------------------- Set and Get Cookie --------------------------------
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function hideLoyaltyButton(){
	var loyalty = getCookie("loyalty-hide");
	console.log(loyalty)
	if( loyalty != "true"){
		$(".close-loyalty-container").css("display", "block");
		$(".close-loyalty").on("click", function(){
			removeLoyaltyButton();
			setCookie("loyalty-hide", "true", 30);
		});
	}
	else if( loyalty == "true"){
		var interval = setInterval( removeLoyaltyButton,250);
		setTimeout( function(){clearInterval(interval);},4000);
	}
}

function removeLoyaltyButton(){
	var loyalty_button = $(".loyaltydog-rewards");
	var cross = $(".close-loyalty-container");
	if(  cross !=0 ){
		$(".loyaltydog-rewards").css("display", "none");
		$(".close-loyalty-container").css("display", "none");
	}
}